import axios from "axios";
import { API } from "@/lib/api";

const BASE = `${API}/games/fifteen`;

export const fifteenApi = {
  leaderboard: async (limit = 20) =>
    (await axios.get(`${BASE}/leaderboard`, { params: { limit } })).data,
  submit: async ({ name, duration_ms, moves }) =>
    (await axios.post(`${BASE}/leaderboard`, { name, duration_ms, moves })).data,
};
